import { render, staticRenderFns } from "./EmailParts.vue?vue&type=template&id=36856f20"
import script from "./EmailParts.vue?vue&type=script&lang=js"
export * from "./EmailParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports